export const checklistInitialState = {
  checklist: [],
  initialState: {},
  tooltip: [],
  novalimpeza: [],
};
